import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
    selector: 'pui-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss' ],
})
export class PuiAlertDialogComponent {
    title: string;
    message: string;
    closeButton: string = 'Close';

    constructor(private dialogRef: MdDialogRef<PuiAlertDialogComponent>) {}

    close(): void {
        this.dialogRef.close();
    }
}
